
<template>
  <div>
    <v-row>
      <v-col cols="12" md="6" v-if="!creating">
        <v-text-field v-model="client.corporateName" :rules="required" label="Razão Social" prepend-icon="mdi-domain"></v-text-field>
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field v-model="client.fantasyName" :rules="required" label="Nome" prepend-icon="mdi-office-building" ref="fantasy_name"></v-text-field>
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field v-model="client.CNPJ" :rules="[...required, ...cnpj]" label="CNPJ" prepend-icon="mdi-line-scan" v-mask="'##.###.###/####-##'"></v-text-field>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import validations from "@/mixins/validations.js"
export default {
  name: 'ClientPJ',
  mixins: [ validations ],
  props:{
    set_client:{
      type: Object,
      default: ()=>{ return {  } }
    },
    type:{
      type: String,
      default:"",
    },
    creating:{
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      client:{
        corporateName: '',
        CNPJ: '',
        fantasyName: ''
      }
    }
  },
  methods: {
    getData(){
      this.client.corporateName = this.set_client.corporateName
      this.client.CNPJ = this.formatCNPJToMask(this.set_client.CNPJ)
      this.client.fantasyName = this.set_client.fantasyName
    },
    validate(){
      return this.$refs.form.validate()
    },
    formatCNPJToMask(cnpj) {
      cnpj = cnpj.replace(/\D/g, '');
      cnpj = cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
      return cnpj;
    },
  },
  mounted(){
    this.getData()
  },
  watch:{
    type(nv){
      this.getData()
    }
  }
}
</script>